export default "__VITE_ASSET__BO1wXigK__"